import { axiosBackendInstance, axiosBackendInstanceV2 } from '../axiosInstance'
import authAxios from '../authAxios'
import axiosWebInstance from '../axiosWebInstance'

export const getFeaturedGameOffers = async (userId) => {
  const { data } = await authAxios.get(`/api/v1/users/${userId}/featuredGames`)

  const mapOffers = (offerIds) => offerIds.map((offerId) => data.sortedOffersById[offerId])
  const rows = {
    activatedRow: mapOffers(data.activatedRowIds),
    libraryRow: mapOffers(data.libraryRowIds),
    featuredRow: mapOffers(data.featuredRowIds),
    genresRows: data.genresRowsIds.map((row) => ({
      ...row,
      offers: Array.isArray(row.offers) ? mapOffers(row.offers) : row.offers,
    })),
  }

  return rows
}

export const claimAggregatedReward = async (offerId) => {
  return axiosBackendInstance.put(`/api/v1/rewards/claim/aggregated/${offerId}`)
}

export const createSpecialReward = async (offerId, data) => {
  return axiosBackendInstance.post(`/api/v1/rewards/special-rewards/${offerId}`, data)
}

export const claimSpecialReward = async (offerId, data) => {
  return axiosBackendInstance.patch(`/api/v1/rewards/claim/special-rewards/${offerId}`, data)
}

export const claimPurchaseReward = async (rewardId) => {
  return axiosBackendInstance.put(`/api/v1/rewards/claim/purchase/${rewardId}`)
}

export const getAllUnclaimedRewards = async () => {
  const resp = await axiosBackendInstanceV2.get(`/api/v1/rewards/unclaimed/all`)
  return resp.data
}

export const claimAllRewards = async () => {
  return axiosWebInstance.post(`/api/v1/rewards/claim/all`)
}
